import SeoHead from "../components/SeoHead";
import ReviewsSection from "../components/ReviewsSection";
import CTABand from "../components/CTABand";
import { PageHeader } from "./Services";
import { SITE, REVIEWS } from "../lib/site";

export default function Avis() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: SITE.legalName,
    url: SITE.url,
    telephone: SITE.phoneRaw,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: SITE.aggregateRating.value,
      reviewCount: SITE.aggregateRating.count,
      bestRating: 5,
      worstRating: 1,
    },
    review: REVIEWS.map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.name },
      reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 },
      reviewBody: r.text,
      datePublished: r.date + "-01",
    })),
  };

  return (
    <div data-testid="avis-page">
      <SeoHead
        title="Avis clients — Termite Bordeaux & Gironde | Note 5/5 Google"
        description="Découvrez les avis vérifiés de nos clients à Bordeaux, Mérignac, Pessac, Bègles. Cabinet noté 5,0/5 sur Google pour le traitement termites et bois en Gironde."
        canonical={SITE.url + "/avis"}
        keywords={["avis termites Bordeaux", "avis Termite Habitat 33", "client termites Gironde"]}
        schema={schema}
        breadcrumbs={[
          { name: "Accueil", url: SITE.url + "/" },
          { name: "Avis", url: SITE.url + "/avis" },
        ]}
      />
      <PageHeader
        eyebrow="Avis Google · 5,0 / 5"
        title="Nos clients témoignent."
        intro="Des particuliers, syndics, notaires et viticulteurs de toute la Gironde nous accordent leur confiance. Avis vérifiés issus de Google."
      />

      <section className="container-x pb-4" data-testid="avis-gbp-cta">
        <div className="max-w-3xl mx-auto bg-white border border-[#D5CABD] rounded-sm p-6 text-center">
          <div className="text-[11px] uppercase tracking-widest text-[#7A2E39] mb-2">
            Fiche Google officielle
          </div>
          <h2 className="font-serif text-2xl text-gray-900 mb-3">
            Consultez tous nos avis sur Google — note 5/5
          </h2>
          <p className="text-gray-700 text-sm mb-4">
            Avis vérifiés par Google, laissés par des clients bordelais, du Médoc, du Bassin
            d'Arcachon et de toute la Gironde. Vous pouvez aussi laisser votre propre avis
            après notre intervention.
          </p>
          <a
            href={SITE.googleBusinessUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            data-testid="avis-gbp-link"
          >
            ⭐ Lire &amp; laisser un avis Google
          </a>
        </div>
      </section>

      <ReviewsSection compact />
      <CTABand />
    </div>
  );
}
